import availableColumnIcon from "../../assets/availableColumn.svg";
import type { Product } from "../../types";

// #############################################################################
// @NOTE
// productTitle is here just to conform with the type
// description is translated in the model compare
// #############################################################################

export const emptyColumn: Product = {
  id: "emptyColumn",
  productTitle: "",
  description: "commons.emptyColumn.description",
  image: { src: availableColumnIcon, width: 50, height: 50 },
  propertyValues: [],
};
